const CalendarDotsIcon = ({
  width,
  height,
  color,
}: {
  width?: string
  height?: string
  color?: string
}) => {
  return (
    <svg
      width={width ?? '20'}
      height={height ?? '20'}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='CalendarDots' clipPath='url(#clip0_8994_4208)'>
        <path
          id='Vector'
          d='M16.25 3.125H3.75C3.40482 3.125 3.125 3.40482 3.125 3.75V16.25C3.125 16.5952 3.40482 16.875 3.75 16.875H16.25C16.5952 16.875 16.875 16.5952 16.875 16.25V3.75C16.875 3.40482 16.5952 3.125 16.25 3.125Z'
          stroke={color ?? 'black'}
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M13.75 1.875V4.375'
          stroke={color ?? 'black'}
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M6.25 1.875V4.375'
          stroke={color ?? 'black'}
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_4'
          d='M3.125 6.875H16.875'
          stroke={color ?? 'black'}
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_5'
          d='M10 11.25C10.5178 11.25 10.9375 10.8303 10.9375 10.3125C10.9375 9.79473 10.5178 9.375 10 9.375C9.48223 9.375 9.0625 9.79473 9.0625 10.3125C9.0625 10.8303 9.48223 11.25 10 11.25Z'
          fill={color ?? 'black'}
        />
        <path
          id='Vector_6'
          d='M13.4375 11.25C13.9553 11.25 14.375 10.8303 14.375 10.3125C14.375 9.79473 13.9553 9.375 13.4375 9.375C12.9197 9.375 12.5 9.79473 12.5 10.3125C12.5 10.8303 12.9197 11.25 13.4375 11.25Z'
          fill={color ?? 'black'}
        />
        <path
          id='Vector_7'
          d='M6.5625 14.375C7.08027 14.375 7.5 13.9553 7.5 13.4375C7.5 12.9197 7.08027 12.5 6.5625 12.5C6.04473 12.5 5.625 12.9197 5.625 13.4375C5.625 13.9553 6.04473 14.375 6.5625 14.375Z'
          fill={color ?? 'black'}
        />
        <path
          id='Vector_8'
          d='M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z'
          fill={color ?? 'black'}
        />
        <path
          id='Vector_9'
          d='M13.4375 14.375C13.9553 14.375 14.375 13.9553 14.375 13.4375C14.375 12.9197 13.9553 12.5 13.4375 12.5C12.9197 12.5 12.5 12.9197 12.5 13.4375C12.5 13.9553 12.9197 14.375 13.4375 14.375Z'
          fill={color ?? 'black'}
        />
      </g>
      <defs>
        <clipPath id='clip0_8994_4208'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CalendarDotsIcon
